var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForgotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 46,
    viewBox: "0 0 34 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6562 17.375H28.25V11.75C28.25 5.54562 23.2044 0.5 17 0.5C10.7956 0.5 5.75 5.54562 5.75 11.75V17.375H4.34375C2.01875 17.375 0.125 19.2669 0.125 21.5938V41.2812C0.125 43.6081 2.01875 45.5 4.34375 45.5H29.6562C31.9813 45.5 33.875 43.6081 33.875 41.2812V21.5938C33.875 19.2669 31.9813 17.375 29.6562 17.375ZM9.5 11.75C9.5 7.61375 12.8637 4.25 17 4.25C21.1362 4.25 24.5 7.61375 24.5 11.75V17.375H9.5V11.75ZM18.875 31.8538V36.125C18.875 37.16 18.0369 38 17 38C15.9631 38 15.125 37.16 15.125 36.125V31.8538C14.0094 31.2031 13.25 30.0069 13.25 28.625C13.25 26.5569 14.9319 24.875 17 24.875C19.0681 24.875 20.75 26.5569 20.75 28.625C20.75 30.0069 19.9906 31.2031 18.875 31.8538Z",
    fill: "#2E2E37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotIcon);
export default __webpack_public_path__ + "static/media/ForgotIcon.029880cf795ebcce1e6e926151d77fc8.svg";
export { ForwardRef as ReactComponent };